"use client";

import { RefObject, useRef } from "react";
import { gsap } from "gsap";

import { Image } from "@/features/common/components/ui/image";

interface Props {
  src: string;
  alt?: string;
  containerRef: RefObject<HTMLDivElement | null>;
}

export default function HeroOverlay({ src, alt, containerRef }: Props) {
  const shapeRef = useRef<HTMLImageElement>(null);

  const onMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!containerRef.current) return;

    const box = containerRef.current.getBoundingClientRect();

    const x = e.clientX - box.left - box.width / 2;
    const y = e.clientY - box.top - box.height / 2;

    gsap.to(shapeRef.current, {
      x: x * 0.1, // movement strength
      y: y * 0.1,
      duration: 0.3,
      ease: "power3.out",
    });
  };

  const onMouseEnter = () => {
    gsap.to(shapeRef.current, {
      scale: 1,
      duration: 0.3,
      ease: "power3.out",
    });
  };

  const onMouseLeave = () => {
    gsap.to(shapeRef.current, {
      x: 0,
      y: 0,
      scale: 1,
      duration: 0.4,
      ease: "power3.out",
    });
  };

  return (
    <div
      className="absolute z-20 flex w-[500px] items-center justify-center"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onMouseMove={onMouseMove}
    >
      <Image
        ref={shapeRef}
        removeWrapper
        alt={alt ?? ""}
        aria-hidden={!alt}
        className="absolute z-10 w-full rounded-md object-cover opacity-100"
        src={src}
      />
    </div>
  );
}
